export default __webpack_public_path__ + "static/media/doc-active.90a1a01b.svg";